module.exports = function(ctx) {
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
__p += '<ul class="list-inline mb-0" id="' +
((__t = ( ctx.wizardKey )) == null ? '' : __t) +
'-nav" role="form">\n	';
 if (!ctx.isRepeaterWidget && ctx.instance.isFirstPage() && ctx.parentPreviousTitle) { ;
__p += '\n	<li class="list-inline-item mr-2">\n		<button class="btn btn-outline-primary btn-wizard-nav-next" type="button" tabindex="0" ref="' +
((__t = ( ctx.wizardKey )) == null ? '' : __t) +
'-topPrevious">\n			Back\n			<span class="d-none d-sm-inline-block">to ' +
((__t = ( ctx.t(ctx.parentPreviousTitle) )) == null ? '' : __t) +
'</span>\n		</button>\n	</li>\n	';
 } ;
__p += ' ';
 if (ctx.buttons.previous) { ;
__p += '\n	<li class="list-inline-item mr-2">\n		<button class="btn btn-outline-primary btn-wizard-nav-previous" type="button" tabindex="0" ref="' +
((__t = ( ctx.wizardKey )) == null ? '' : __t) +
'-previous">\n			' +
((__t = ( ctx.t('previous') )) == null ? '' : __t) +
'\n		</button>\n	</li>\n	';
 } ;
__p += ' ';
 if (ctx.buttons.next) { ;
__p += '\n	<li class="list-inline-item">\n		<button class="btn btn-primary btn-wizard-nav-next" tabindex="0" ref="' +
((__t = ( ctx.wizardKey )) == null ? '' : __t) +
'-next">\n			' +
((__t = ( ctx.t('next') )) == null ? '' : __t) +
'\n		</button>\n	</li>\n	';
 } ;
__p += ' ';
 if (ctx.isRepeaterWidget && !ctx.buttons.next) { ;
__p += '\n	<li class="list-inline-item">\n		<button class="btn btn-primary" tabindex="0" ref="' +
((__t = ( ctx.wizardKey )) == null ? '' : __t) +
'-saveEditRow">\n			Save and Return\n		</button>\n	</li>\n	';
 } ;
__p += ' ';
 if (!ctx.isRepeaterWidget && ctx.instance.isLastPage() && ctx.parentNextTitle) { ;
__p += '\n	<li class="list-inline-item">\n		<button class="btn btn-primary btn-wizard-nav-next" tabindex="0" ref="' +
((__t = ( ctx.wizardKey )) == null ? '' : __t) +
'-topNext">\n			Save and Continue\n		</button>\n	</li>\n	';
 } ;
__p += '\n</ul>\n';
return __p
}